// ===============================================================

// ✅ IncomingCallCard.js — LIVORA Premium Incoming Call UI

// ===============================================================



import React from "react";

import { useTranslation } from "react-i18next";

import "./IncomingCallCard.css";



export default function IncomingCallCard({

  incoming,

  caller,

  isMatch,

  accepting = false,

  joining = false,

  onAccept,

  onReject,

}) {

  const { t } = useTranslation();

  const fallbackAvatar = "/images/default-avatar.png";



  const avatar =

    caller?.photoURL ||

    caller?.avatar ||

    caller?.profileImage ||

    fallbackAvatar;



  const name = caller?.displayName || caller?.name || t("calls.unknown_user", { defaultValue: "User" });

  const isJoining = joining || accepting;



  return (

    <div className="livora-incoming-overlay">

      <div className="livora-incoming-backdrop" />



      <div className="livora-incoming-card">

        <div className="livora-incoming-badge">

          {isMatch

            ? t("calls.incoming.match_badge", { defaultValue: "Livora Match" })

            : t("calls.incoming.call_badge", { defaultValue: "Livora Call" })}

        </div>



        <div className="livora-incoming-avatar-wrap">

          <div className="livora-incoming-avatar-ring" />

          <img

            src={avatar}

            alt={name}

            className="livora-incoming-avatar"

            onError={(e) => {

              e.currentTarget.onerror = null;

              e.currentTarget.src = fallbackAvatar;

            }}

          />

        </div>



        <h3 className="livora-incoming-title">

          {isJoining

            ? t("calls.joining_call", { defaultValue: "Joining call..." })

            : isMatch

              ? t("calls.incoming.match_title", { defaultValue: "New match" })

              : t("calls.incoming.call_title", { defaultValue: "Incoming call" })}

        </h3>



        <div className="livora-incoming-name">{name}</div>



        {isJoining ? (

          <div className="livora-incoming-joining">

            <div className="livora-incoming-joining-spinner" aria-hidden="true" />

            <p className="livora-incoming-subtitle">

              {t("calls.joining_call_hint", {

                defaultValue: "Opening the call room...",

              })}

            </p>

          </div>

        ) : (

          <p className="livora-incoming-subtitle">

            {isMatch

              ? t("calls.incoming.match_subtitle", { defaultValue: "A suitable call was found for you" })

              : t("calls.incoming.call_subtitle", { defaultValue: "Wants to start a video call with you" })}

          </p>

        )}



        {!isJoining && (

          <div className="livora-incoming-actions">

            <button

              type="button"

              className="livora-incoming-btn reject"

              onClick={onReject}

            >

              {t("calls.actions.decline", { defaultValue: "Decline" })}

            </button>



            <button

              type="button"

              className="livora-incoming-btn accept"

              onClick={onAccept}

            >

              {isMatch

                ? t("calls.actions.start_match", { defaultValue: "Start match" })

                : t("calls.actions.accept", { defaultValue: "Accept" })}

            </button>

          </div>

        )}

      </div>

    </div>

  );

}

